import React from "react";
import { AboutHeroWrap } from "./AboutHero.styled";

const AboutHero = () => {
  return (
    <AboutHeroWrap>
      <div>
        <h2>About Us</h2>
      </div>
    </AboutHeroWrap>
  );
};

export default AboutHero;
